<script setup lang="ts">
import { ElConfigProvider } from 'element-plus';
import { RouterView } from 'vue-router';
import { elLocaleMap } from './store/locale';
import { LocaleType } from './store/locale';
import '@/style/base.scss';
import customFont from './utils/customFont'; // 按需加载自定义字体
const { getCurrentLocale } = useStore('locale');
const language = computed(() => elLocaleMap[getCurrentLocale.value as LocaleType]);
// customFont();
const { setTitle } = useStore('common');
const route = useRoute();

watch(
    () => route,
    curRoute => {
        setTitle(curRoute.query.title);
    },
    { immediate: true, deep: true }
);
</script>
<template>
    <el-config-provider :locale="language">
        <RouterView />
    </el-config-provider>
</template>

<style lang="less">
@import '@/style/format.less';
</style>
